// noinspection JSUnusedGlobalSymbols
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map, switchMap, take } from 'rxjs/operators';

import { RowStatusSelectDialogComponent } from 'app/shared/components/row-status-select-dialog/row-status-select-dialog.component';
import { resetApiConfig } from 'app/state/api-config/api-config.actions';
import { openDialog } from 'app/state/app-state/app-state.actions';
import { selectPreliminaryRowRegistrationStatus } from 'app/state/registrations/registrations.selectors';

import { resetRowSelection, startRowRegistrationStatusSelection } from './row-selection.actions';

// noinspection JSUnusedGlobalSymbols
@Injectable({
    providedIn: 'root',
})
export class RowSelectionEffects {
    startRowRegistrationStatusSelection$ = createEffect(() =>
        this.actions$.pipe(
            ofType(startRowRegistrationStatusSelection),
            switchMap(({ activityNumber, rowNumber }) => {
                const preliminaryRegistrationStatus$ = this.store
                    .select(selectPreliminaryRowRegistrationStatus({ activityNumber, rowNumber }))
                    .pipe(take(1));

                return preliminaryRegistrationStatus$.pipe(
                    map((preliminaryRegistrationStatus) => {
                        return openDialog({
                            dialog: {
                                component: RowStatusSelectDialogComponent,
                                inputs: { rowNumber, preliminaryRegistrationStatus },
                            },
                        });
                    }),
                );
            }),
        ),
    );

    resetRowSelectionOnResetApiConfig$ = createEffect(() =>
        this.actions$.pipe(
            ofType(resetApiConfig),
            map(() => resetRowSelection()),
        ),
    );

    constructor(
        private actions$: Actions,
        private store: Store,
    ) {}
}
